<div *ngIf="_data?.length > 0" class="custom-select-wrapper" (click)="openCloseSelector($event)">
  <div class="custom-select border-{{ category }}" [ngClass]="open ? 'open' : ''">
    <div class="custom-select__trigger">
      <span class="truncate">{{ category === '' ? genericActivity : currentActivity }}</span>
      <div class="arrow"></div>
    </div>
    <div class="custom-options-container" [ngStyle]="{ left: '0' }">
      <div class="custom-options" [style.height.px]="elHeight + 20">
        <div class="options-col first-col">
          <svg-icon key="cross-icon" class="aria-hidden ml-2" size="xs"></svg-icon>
        </div>
        <div class="grid grid-cols-4 grid-rows-2">
          <ng-container *ngFor="let element of _data; let i = index">
            <div [ngClass]="[i < 3 ? 'row-span-2' : '']">
              <div id="{{ element.categoryTitle }}" class="options-col" [ngClass]="{ 'h-fitted': i !== _data.length - 2 }">
                <h3>{{ element.categoryTitle }}</h3>
                <ng-container *ngFor="let item of element.activities">
                  <div
                    (click)="emitClick(item, false)"
                    class="custom-option flex justify-between gap-3 {{ item?.link ? '' : getMappedStyle(item.style) }}"
                    [ngClass]="{
                      'activity-item': item?.link,
                      'pointer-events-none': item?.isHidden && !isTeacher,
                      'opacity-50': item.disabled
                    }"
                    data-value="{{ item.title }}"
                    [value]="item.title">
                    <div class="flex items-center">
                      <svg-icon
                        *ngIf="item.link"
                        [key]="item.style === activityTypology.VIDEO_ACTIVITY ? 'play' : 'download'"
                        [size]="item.style === activityTypology.VIDEO_ACTIVITY ? 'lg' : 'md'"
                        class="mr-2"></svg-icon>
                      <span class="activities__ellipsis" [ngClass]="{ 'text-disabled': item?.isHidden && !isTeacher }">
                        {{ _data.length === 1 ? item.title : item.typologyTitle }}
                      </span>
                      <svg-icon *ngIf="item.isHidden" key="disable-circle" class="aria-hidden ml-2" size="sm"></svg-icon>
                    </div>
                    <zero-exercise-status
                      *ngIf="item.completedExcercises !== undefined && item.totalExcercises !== undefined"
                      [completedExcercises]="item.completedExcercises"
                      [totalExcercises]="item.totalExcercises"
                      [isSent]="item.isSent"></zero-exercise-status>
                  </div>
                  <div
                    *ngIf="item.solutionaryLink && isTeacher"
                    class="custom-option {{ item?.link ? '' : getMappedStyle(item.style) }}"
                    [ngClass]="{
                      'activity-item': item?.link,
                      'pointer-events-none': item?.isHidden && !isTeacher,
                    }"
                    data-value="{{ item.title }}">
                    <div
                      class="flex items-center"
                      [ngClass]="{
                        'opacity-50': item.disabled
                      }"
                      (click)="emitClick(item, true)">
                      <svg-icon
                        *ngIf="item.solutionaryLink"
                        [key]="item.style === activityTypology.VIDEO_ACTIVITY ? 'play' : 'download'"
                        [size]="item.style === activityTypology.VIDEO_ACTIVITY ? 'lg' : 'md'"
                        class="mr-2"></svg-icon>
                      <span class="activities__ellipsis" [ngClass]="{ 'text-disabled': item?.isHidden && !isTeacher }">
                        {{ _data.length === 1 ? item.title : item.typologyTitle }}
                        ({{ 'f.generic.solutionary' | translate }})
                      </span>
                      <svg-icon *ngIf="item.isHidden" key="disable-circle" class="aria-hidden ml-2" size="sm"></svg-icon>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
